//LL:  created 24.12.19

import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import EditComponent from '../tsx/MappingField';

export class MappingField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = MappingField.getDefaultValue();
        }

        super(glob, title, MappingField.defaultValidators, validators, defaultVal, options);
    }
}
